<ng-template #icon let-i>
  @if (i) {
    @switch (i.type) {
      @case ('icon') {
        <i class="sidebar-nav__item-icon" nz-icon [nzType]="i.value" [nzTheme]="i.theme" [nzSpin]="i.spin"
           [nzTwotoneColor]="i.twoToneColor" [nzIconfont]="i.iconfont" [nzRotate]="i.rotate"></i>
      }
      @case ('iconfont') {
        <i class="sidebar-nav__item-icon" nz-icon [nzIconfont]="i.iconfont"></i>
      }
      @case ('img') {
        <img title="icon" [src]="i.value" class="sidebar-nav__item-icon sidebar-nav__item-img" />
      }
      @case ('svg') {
        <span class="sidebar-nav__item-icon sidebar-nav__item-svg" [innerHTML]="i.value"></span>
      }
      @default {
        <i class="sidebar-nav__item-icon {{ i.value }}"></i>
      }
    }
  }
</ng-template>

<ng-template #tree let-ls>
  @for (menu of ls; track $index) {
    @if (menu._hidden !== true) {
      <li class="sidebar-nav__item" [class.sidebar-nav__selected]="menu._selected"
          [class.sidebar-nav__open]="menu.open">
        <!-- link -->
        @if (menu.children.length === 0) {
          <a [routerLink]="getRouterLink(menu)" [attr.data-id]="menu._id" class="sidebar-nav__item-link"
             [ngClass]="{ 'sidebar-nav__item-disabled': menu.disabled }" (click)="to(menu, $event)" (mouseenter)="closeSubMenu()">
            @if (menu._needIcon) {
              @if (collapsed) {
                <span nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="menu.text">
        <ng-template [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{ $implicit: menu.icon }" />
      </span>
              } @else {
                <ng-template [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{ $implicit: menu.icon }" />
              }
            }
            <span class="sidebar-nav__item-label">
        <span class="sidebar-nav__item-text" [attr.title]="menu.text">{{ menu.text }}</span>
              @if (menu.beta) {
                <span class="beta-badge">Beta</span>
              }
      </span>
          </a>
        }
        <!-- has children link -->
        @if (menu.children.length > 0) {
          <a [href]="getFirstChildLink(menu)" (click)="onParentClick($event, menu)" (mouseenter)="showSubMenu($event, menu)" class="sidebar-nav__item-link">
            <ng-template [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{ $implicit: menu.icon }" />
            <span class="sidebar-nav__item-text" [innerHTML]="menu._text" [attr.title]="menu.text"></span>
            <i class="sidebar-nav__sub-arrow"></i>
          </a>
        }
        <!-- badge -->
        @if (menu.badge) {
          <nz-badge [nzCount]="menu.badge" [nzDot]="menu.badgeDot" nzStandalone [nzOverflowCount]="9" />
        }
        @if (menu.children.length > 0) {
          <ul class="sidebar-nav sidebar-nav__sub sidebar-nav__depth{{ menu._depth }}">
            <ng-template [ngTemplateOutlet]="tree" [ngTemplateOutletContext]="{ $implicit: menu.children }" />
          </ul>
        }
      </li>
    }
  }
</ng-template>
<ul class="sidebar-nav">
  @for (group of list; track $index) {
    @if (group.group) {
      <li class="sidebar-nav__item sidebar-nav__group-title">
        <span [innerHTML]="group._text"></span>
      </li>
    }
    <ng-template [ngTemplateOutlet]="tree" [ngTemplateOutletContext]="{ $implicit: group.children }" />
  }
</ul>

<!-- <ul nz-menu nzMode="inline" nzTheme="dark" class="sidebar-nav" *ngIf="newMenu" class="bg-primary-dark text-white">
  @for (group of list; track $index) {
    <ng-container [ngTemplateOutlet]="menuTpl" [ngTemplateOutletContext]="{ $implicit: group.children }" />
  }
  <ng-template #menuTpl let-menus>
    @for (menu of menus; track menu) {
      @if (!menu.children?.length) {
        <li nz-menu-item [nzPaddingLeft]="menu._depth* 24" [nzDisabled]="menu.disabled" [nzSelected]="menu.selected">
          @if (menu._needIcon) {
            @if (collapsed) {
              <span nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="menu.text">
        <ng-template [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{ $implicit: menu.icon }" />
      </span>
            } @else {
              <ng-template [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{ $implicit: menu.icon }" />
            }
          }
          <span>{{ menu.text }}</span>
        </li>
      } @else {
        <li nz-submenu [nzPaddingLeft]="menu._depth * 12" [nzOpen]="menu.open" [nzDisabled]="menu.disabled"
            [nzTitle]="subMenuTitle">
          <ng-template #subMenuTitle>
            @if (menu._needIcon) {
              @if (collapsed) {
                <span nz-tooltip nzTooltipPlacement="right" [nzTooltipTitle]="menu.text">
          <ng-template [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{ $implicit: menu.icon }" />
        </span>
              } @else {
                <ng-template [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{ $implicit: menu.icon }" />
              }
            }
            <span>{{ menu.text }}</span>
          </ng-template>
          <ul>
            <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }" />
          </ul>
        </li>
      }
    }
  </ng-template>
</ul> -->
